import React, { useEffect, useRef, useState } from 'react';
import './QuantumEquations.css';

const EQUATIONS = [
  '𝐻|ψ⟩ = E|ψ⟩',
  '|ψ⟩ = α|0⟩ + β|1⟩',
  '⟨ψ|ψ⟩ = 1',
  'Δx·Δp ≥ ħ/2',
  '|+⟩ = (|0⟩ + |1⟩)/√2',
  '|−⟩ = (|0⟩ − |1⟩)/√2',
  'σₓ = [[0, 1], [1, 0]]',
  'σᵧ = [[0, -i], [i, 0]]',
  'σ𝓏 = [[1, 0], [0, -1]]',
  'U = e^{-iHt/ħ}',
  '𝐻 = p²/2m + V(x)',
  '⟨ϕ|ψ⟩',
  'Eₙ = (n + ½)ℏω',
  '[𝐻, 𝐴] = iħ𝐵',
  '|ψ(t)⟩ = U(t)|ψ(0)⟩',
];

function getRandom(min, max) {
  return Math.random() * (max - min) + min;
}

function generateInitialEquations(dense = false) {
  const base = [...EQUATIONS];
  if (dense) for (let i = 0; i < 4; i++) base.push(...EQUATIONS);
  return base.map((text, i) => ({
    id: i,
    text,
    top: getRandom(0, 90),
    left: getRandom(0, 90),
    direction: {
      x: getRandom(-1, 1),
      y: getRandom(-1, 1),
      scale: getRandom(0.8, 1.5),
    },
    offset: { x: 0, y: 0 },
  }));
}

export default function QuantumEquations({ isScrolling, dense = false }) {
  const [eqStates, setEqStates] = useState(() => generateInitialEquations(dense));
  // const rafRef = useRef();

  useEffect(() => {
    let animationFrame;
    const animate = () => {
      setEqStates((prev) =>
        prev.map((eq) => {
          const { offset, direction, top, left } = eq;
          const speed = isScrolling ? 0.1 : 0;

          let newX = left + offset.x + direction.x * speed;
          let newY = top + offset.y + direction.y * speed;

          if (!isScrolling) {
            return {
              ...eq,
              offset: {
                x: offset.x + (0 - offset.x) * 0.05,
                y: offset.y + (0 - offset.y) * 0.05,
              },
            };
          }

          if (newX > 100) newX = -10;
          if (newX < -10) newX = 100;
          if (newY > 100) newY = -10;
          if (newY < -10) newY = 100;

          return {
            ...eq,
            offset: {
              x: newX - left,
              y: newY - top,
            },
          };
        })
      );

      animationFrame = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(animationFrame);
  }, [isScrolling]);

  return (
    <div className="quantum-equations-container" style={{ pointerEvents: 'none', zIndex: 5 }}>
      {eqStates.map((eq) => (
        <div
          key={eq.id}
          className="equation"
          style={{
            top: `${eq.top + eq.offset.y}%`,
            left: `${eq.left + eq.offset.x}%`,
            transform: `scale(${eq.direction.scale})`,
          }}
        >
          {eq.text}
        </div>
      ))}
    </div>
  );
}
